import React from "react";
import { ICreateTaskModalProps } from "./definitions";
import styles from "./style.module.scss";
import Modal from "@amzn/awsui-components-react/polaris/modal";
import CreateTaskForm from "../create-task-form/CreateTaskForm";

const CreateTaskModal: React.FC<ICreateTaskModalProps> = ({
  parentTaskId,
  visible,
  setVisible,
  parentCategory,
  onCreate,
}: ICreateTaskModalProps) => {
  const [resetForm, setResetForm] = React.useState(0);
  const onDismiss = (e: any) => {
    if (e.detail.reason == "overlay") return;
    setVisible(false);
    setResetForm(resetForm + 1);
  };

  return (
    <>
      <Modal onDismiss={onDismiss} visible={visible} header="Add task">
        <CreateTaskForm
          parentTaskId={parentTaskId}
          setVisible={setVisible}
          resetForm={resetForm}
          parentCategory={parentCategory}
          onCreate={onCreate}
        ></CreateTaskForm>
      </Modal>
    </>
  );
};

export default CreateTaskModal;
